import noPortalApiClient from 'hub-http/clients/noPortalApiClient';
import { createTracker } from 'usage-tracker';
import events from 'UserPreferencesUI/events.yaml';
const baseTracker = createTracker({
  events,
  properties: {
    namespace: 'user-preferences'
  },
  allowUnauthed: true
});
export let tracker = baseTracker;
export const enableHublessTracking = () => {
  return noPortalApiClient.get('/login-verify/user-info')
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'user' does not exist on type 'JSON'.
  .then(({
    user
  }) => user.emails[0]).then(email => {
    tracker = baseTracker.clone({
      properties: {
        hubId: null,
        email
      }
    });
  });
};
export const trackScreen = screen => {
  tracker.track('pageView', {
    screen
  });
};
export const securityPhoneNumberNudgeInitiated = () => {
  tracker.track('securityPhoneNumberNudge', {
    action: 'Initiated'
  });
};
export const securityPhoneNumberNudgeDismissed = () => {
  tracker.track('securityPhoneNumberNudge', {
    action: 'Dismissed'
  });
};
export const securityPhoneNumberNudgeAccomplished = () => {
  tracker.track('securityPhoneNumberNudge', {
    action: 'Accomplished'
  });
};